import { createButton, type ButtonStyles } from '@gokrew/ui';
import styles from './Button.module.css';

export const { Button, IconButton } = createButton(styles as unknown as ButtonStyles);
